module.exports = __webpack_public_path__ + "img/htsq.6edba60d.jpg";